"use strict";
import L from "leaflet";
import "leaflet.markercluster/dist/leaflet.markercluster.js";
window.L = L;
export default window.L;
